import { useRouter } from 'next/navigation';
import { IconButton } from '@/app/components/buttons/IconButton';
import { DASHBOARD_PATH } from '@/consts/paths';
import type { CalendarViewMode } from '@/types/calendarTypes';
import { cn } from '@/utils/сn';
import ArrowLeftIcon from '/public/icons/arrow-back.svg';
import ChevronRightIcon from '/public/icons/chevron-right-pagination.svg';

interface CalendarMobileHeaderProps {
  onPrevious: () => void;
  onNext: () => void;
  handleViewSegment: (view: CalendarViewMode) => void;
  view: CalendarViewMode;
  navTitle: string;
  isWidget: boolean;
}

export function CalendarMobileHeader({
  onPrevious,
  onNext,
  handleViewSegment,
  view,
  navTitle,
  isWidget,
}: CalendarMobileHeaderProps) {
  const router = useRouter();
  const mobileView = view === 'day' ? 'day' : 'month';

  const onBack = () => {
    router.push(DASHBOARD_PATH);
  };

  return (
    <div
      className={cn('flex flex-col items-center gap-1.5 px-4', {
        'md:hidden flex': !isWidget,
        hidden: isWidget,
      })}
    >
      <div className="flex w-full items-center justify-between px-1 pt-3">
        <button type="button" onClick={onBack} className="flex w-12 items-center justify-center">
          <ArrowLeftIcon className="h-4 w-4 fill-current text-blue-300" />
        </button>
        <p className="truncate font-canela font-light text-lg text-body-light text-blue-300">Calendar</p>
        <button
          type="button"
          onClick={() => handleViewSegment(mobileView === 'day' ? 'month' : 'day')}
          className="flex w-12 items-center justify-center whitespace-nowrap font-inter text-sm font-medium text-blue-300"
        >
          {mobileView === 'day' ? 'Month View' : 'Day View'}
        </button>
      </div>
      <div className="flex w-full items-center justify-between">
        <IconButton
          size="medium"
          icon={<ChevronRightIcon className="h-4 w-4 min-h-4 min-w-4 rotate-180 text-blue-300" />}
          aria-label="Previous"
          onClick={onPrevious}
        />
        <p className="truncate font-inter text-sm font-semibold text-blue-300">{navTitle}</p>
        <IconButton
          size="medium"
          icon={<ChevronRightIcon className="h-4 w-4 min-h-4 min-w-4 text-blue-300" />}
          aria-label="Next"
          onClick={onNext}
        />
      </div>
    </div>
  );
}
